'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEUTRAL_BRANDING_ROUTES = undefined;
exports.isNeutralBrandingRoute = isNeutralBrandingRoute;

var _Router = require('./Router');

var NEUTRAL_BRANDING_ROUTES = exports.NEUTRAL_BRANDING_ROUTES = [_Router.RouterConst.ResetPassword, _Router.RouterConst.ResetPasswordConfirmation, _Router.RouterConst.ResetPasswordExpired, _Router.RouterConst.ForgotPassword, _Router.RouterConst.ConfirmForgotPassword];

function isNeutralBrandingRoute(pathname) {
  if (typeof pathname !== 'string') return false;

  var pathSegments = pathname.split('/').filter(Boolean);
  return pathSegments.some(function (segment) {
    return NEUTRAL_BRANDING_ROUTES.includes(segment);
  });
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/NeutralBrandingRoutes.js
// module id = 142
// module chunks = 0